import { HeartHandshake, Instagram, GraduationCap, Briefcase, Mic, Stethoscope, Award, Zap } from "lucide-react";
import Reveal from "@/components/Reveal";

const DAILY = [
  {
    icon: HeartHandshake,
    text: "Ricevo in visita con colloqui senza fretta, per abbattere le paure e mettere a proprio agio.",
    id: "visite",
  },
  {
    icon: Instagram,
    text: "Parlo di proctologia senza tabù sulla mia pagina, con parole semplici che tutti possono capire.",
    id: "social",
  },
  {
    icon: GraduationCap,
    text: "Studio e pubblico: oltre 96 lavori su riviste nazionali e internazionali.",
    id: "ricerca",
  },
];

export default function Bio() {
  return (
    <section id="chisono" className="relative py-28 overflow-hidden">
      <div className="absolute top-20 -right-40 w-[480px] h-[480px] rounded-full bg-gold/8 blur-[130px]" />
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-14 items-center">
        <Reveal className="lg:col-span-7 relative">
          <svg viewBox="0 0 64 64" className="absolute -top-8 -left-8 w-40 h-40 opacity-[0.06]" aria-hidden="true">
            <circle cx="32" cy="32" r="30" fill="none" stroke="#D4A359" strokeWidth="1" />
            <text x="32" y="41" textAnchor="middle" fontFamily="Playfair Display, Georgia, serif" fontStyle="italic" fontSize="26" fill="#D4A359">RD</text>
          </svg>
          <p className="eyebrow">Chi sono</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 tracking-tight">
            Sono il Dott. <span className="italic text-gold">Roberto Di Lorenzo.</span>
          </h2>
          <p className="mt-7 text-lg text-silver font-light leading-relaxed">
            Da più di 30 anni mi occupo di colonproctologia. In quel tempo ho eseguito con successo
            migliaia di procedure e pubblicato oltre 96 lavori su riviste nazionali e
            internazionali. Ma quello che mi appassiona di più è l'altra metà del mio lavoro: le
            persone.
          </p>
          <p className="mt-5 text-lg text-silver font-light leading-relaxed">
            Perché all'ansia e all'imbarazzo che portano tutti i miei pazienti rispondo con la
            stessa cura che dedico alla tecnica: ascolto senza fretta, parole semplici, nessun
            tabù. In ambulatorio a Palermo e sulla mia pagina Instagram, ogni giorno, aiuto le
            persone a tornare serene alla propria vita quotidiana.
          </p>
          <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {[
              { icon: GraduationCap, text: "Laurea in Medicina e Chirurgia — Università degli Studi di Palermo, novembre 1992." },
              { icon: Stethoscope, text: "Specializzazione in Chirurgia d'Urgenza e Pronto Soccorso — Università degli Studi di Palermo, 1996." },
              { icon: Award, text: "Master di I e II livello in Colo-Proctologia, 1996." },
              { icon: Briefcase, text: "Dal 2002 Dirigente Medico presso la U.O.C. di Medicina d'Urgenza e Pronto Soccorso del Policlinico Universitario di Palermo." },
              { icon: Zap, text: "Perfezionamento in Chirurgia Laser Mini-invasiva in Proctologia, 2019." },
              { icon: Mic, text: "Organizzatore e relatore a congressi nazionali e internazionali." },
            ].map((item, i) => {
              const Icon = item.icon;
              return (
                <div
                  key={i}
                  className="flex items-start gap-4 rounded-2xl border border-white/10 bg-card/60 px-5 py-4"
                  data-testid={`bio-credential-${i}`}
                >
                  <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-sage/30 border border-sagelight/30 text-sagelight shrink-0">
                    <Icon size={17} />
                  </span>
                  <p className="text-silver text-sm leading-relaxed pt-1.5">{item.text}</p>
                </div>
              );
            })}
          </div>
          <p className="mt-9 font-display italic text-2xl text-ivory">— Roberto Di Lorenzo</p>
        </Reveal>

        <div className="lg:col-span-5">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.28em] text-gold mb-4">Ogni giorno</p>
          </Reveal>
          <div className="flex flex-col gap-4">
            {DAILY.map(({ icon: Icon, text, id }, i) => (
              <Reveal key={id} delay={0.08 + i * 0.07}>
                <div
                  className="flex items-start gap-4 rounded-2xl border border-white/10 bg-card/60 px-5 py-4 transition-colors hover:border-gold/30"
                  data-testid={`bio-daily-card-${id}`}
                >
                  <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-gold/10 border border-gold/20 text-gold shrink-0">
                    <Icon size={17} />
                  </span>
                  <p className="text-ivory/90 text-sm leading-relaxed pt-1.5">{text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
